<template>
  <div class="vehicle-shipment-modal-root">
    <transition name="modal-fade">
      <div
        v-if="addNewDataLocal"
        class="modern-modal__overlay"
        @click.self="closeForm">
        <div class="modern-modal">
          <header class="modern-modal__header">
            <div>
              <h3 class="modern-modal__title">{{ title }}</h3>
              <p v-if="editMode" class="modern-modal__subtitle">
                Update the shipment details below, then choose Update to save your changes.
              </p>
              <p v-else class="modern-modal__subtitle">
                Fill in the vehicle shipment form below to create a new record.
              </p>
            </div>
            <button class="modern-modal__close" type="button" @click="closeForm">
              <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
            </button>
          </header>

          <section class="modern-modal__body">
            <div class="modern-modal__scroll">
              <div class="modal-grid">
                <div class="modal-column">
                  <div class="field-group vs-component vs-con-input-label vs-input w-full vs-input-primary">
                    <label class="vs-input--label">License Plate<sup>*</sup></label>
                    <v-select
                      placeholder="- Select License Plate -"
                      :clearable="false"
                      :value="getSelectValue(license_plate, list_license_plate)"
                      :options="list_license_plate"
                      label="text"
                      :reduce="(option) => option.value"
                      @input="onLicensePlateChange" />
                  </div>
                </div>

                <div class="modal-column">
                  <div class="field-group vs-component vs-con-input-label vs-input w-full vs-input-primary">
                    <label class="vs-input--label">Shipment No<sup>*</sup></label>
                    <div class="vs-con-input">
                      <input
                        type="text"
                        v-model="shipment_no"
                        name="shipment_no"
                        class="vs-inputx vs-input--input normal"
                        placeholder="Enter shipment number" />
                    </div>
                    <span></span>
                  </div>
                </div>

                <div class="modal-column">
                  <div class="field-group vs-component vs-con-input-label vs-input w-full vs-input-primary">
                    <label class="vs-input--label">Send Status<sup>*</sup></label>
                    <v-select
                      placeholder="- Select Send Status -"
                      :clearable="false"
                      :value="getSelectValue(send_status, options)"
                      :options="options"
                      label="text"
                      :reduce="(option) => option.value"
                      @input="onSendStatusChange" />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <footer class="modern-modal__footer">
            <vs-button
              v-if="!editMode"
              class="vs-con-loading__container"
              color="primary"
              :disabled="!isFormValid"
              @click="storeVehicleShipment">
              Save
            </vs-button>
            <vs-button
              v-if="editMode"
              class="vs-con-loading__container"
              color="primary"
              :disabled="!isFormValid"
              @click="updateVehicleShipment">
              Update
            </vs-button>
            <vs-button color="warning" type="border" @click="closeForm">
              Cancel
            </vs-button>
          </footer>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import * as REPO from '../../../repository/index'

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true,
    },
    title: String,
    dataEdit: Object,
    editMode: Boolean,
  },
  data() {
    return {
      list_license_plate: [],
      license_plate: '',
      shipment_no: '',
      send_status: '',
      options: [
        { value: '1', text: 'Send' },
        { value: '0', text: 'Not Send' },
      ],
    }
  },
  created() {
    this.getAllVehicle()
  },
  watch: {
    dataEdit: {
      handler(val) {
        if (!val || Object.keys(val).length === 0) {
          return
        }

        this.license_plate = val.license_plate || ''
        this.shipment_no = val.shipment_no != null ? String(val.shipment_no) : ''
        this.onSendStatusChange(val.send_status)
      },
      deep: true,
    },
    editMode(val) {
      if (!val) {
        this.clearFields()
      }
    },
  },
  computed: {
    addNewDataLocal: {
      get() {
        if (!this.editMode) {
          this.clearFields()
        }
        return this.addNewData
      },
      set(val) {
        if (!val) {
          this.$emit('closeModal')
        }
      },
    },
    isFormValid() {
      const trimmedShipmentNo = (this.shipment_no || '').trim()
      return !!this.license_plate && !!trimmedShipmentNo && this.send_status !== ''
    },
  },
  methods: {
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.license_plate = ''
      this.shipment_no = ''
      this.send_status = ''
    },
    getSelectValue(value, options) {
      return options.find((option) => option.value === value) || null
    },
    getAllVehicle() {
      REPO.getListVehicle({ limit: 9999 })
        .then((res) => {
          const response = res && res.data && res.data.data ? res.data.data : {}
          const items = response.data || []
          this.list_license_plate = items.map((item) => ({
            value: item.license_plate,
            text: item.license_plate,
          }))
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error',
            text: 'Unable to load license plate data',
            color: 'danger',
            position: 'top-right',
          })
        })
    },
    onLicensePlateChange(selection) {
      if (selection && Object.prototype.hasOwnProperty.call(selection, 'value')) {
        this.license_plate = selection.value
      } else {
        this.license_plate = selection || ''
      }
    },
    onSendStatusChange(selection) {
      if (selection && Object.prototype.hasOwnProperty.call(selection, 'value')) {
        this.send_status = selection.value
      } else if (selection === 0 || selection === '0') {
        this.send_status = '0'
      } else if (selection === 1 || selection === '1' || selection === true) {
        this.send_status = '1'
      } else {
        this.send_status = ''
      }
    },
    updateVehicleShipment() {
      const hasId = this.dataEdit && this.dataEdit.id
      if (!this.isFormValid || !hasId) {
        return
      }
      REPO.updateVehicleShipment(
        {
          license_plate: this.license_plate,
          shipment_no: this.shipment_no,
          send_status: this.send_status === '' ? '' : Number(this.send_status),
        },
        this.dataEdit.id
      ).then(() => {
        this.$vs.notify({
          title: 'Success',
          text: 'Data has been updated',
          color: 'success',
          position: 'top-right',
        })
        this.closeForm()
      })
    },
    storeVehicleShipment() {
      if (!this.isFormValid) {
        return
      }
      REPO.postVehicleShipment({
        license_plate: this.license_plate,
        shipment_no: this.shipment_no,
        send_status: this.send_status === '' ? '' : Number(this.send_status),
      }).then(() => {
        this.$vs.notify({
          title: 'Success',
          text: 'Data has been saved',
          color: 'success',
          position: 'top-right',
        })
        this.closeForm()
      })
    },
  },
}
</script>

<style scoped>
.vehicle-shipment-modal-root {
  display: contents;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}

.modern-modal__overlay {
  position: fixed;
  top: 64px;
  left: 260px;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  z-index: 2147483647;
  overflow-y: auto;
}

.modern-modal {
  width: min(640px, 96vw);
  max-height: 80vh;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modern-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 32px 18px;
  border-bottom: 1px solid #e2e8f0;
  gap: 16px;
}

.modern-modal__title {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.modern-modal__subtitle {
  margin: 6px 0 0;
  font-size: 0.9rem;
  line-height: 1.4;
  color: #64748b;
  max-width: 540px;
}

.modern-modal__close {
  background: transparent;
  border: none;
  border-radius: 9999px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.modern-modal__close:hover {
  background: rgba(148, 163, 184, 0.25);
}

.modern-modal__body {
  padding: 22px 30px;
  overflow: hidden;
}

.modern-modal__scroll {
  max-height: calc(80vh - 180px);
  overflow-y: auto;
  padding-right: 6px;
}

.modern-modal__scroll::-webkit-scrollbar {
  width: 6px;
}

.modern-modal__scroll::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.6);
  border-radius: 9999px;
}

.modern-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 32px 26px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.modal-grid {
  display: grid;
  gap: 16px;
}

.modal-column {
  width: 100%;
}

.field-group {
  background: rgba(241, 245, 249, 0.65);
  border-radius: 14px;
  padding: 18px 18px 12px;
  border: 1px solid rgba(203, 213, 225, 0.6);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}

.field-group:hover {
  border-color: rgba(148, 163, 184, 0.8);
}

.field-group:focus-within {
  border-color: #2563eb;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group .vs-input--label {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
  letter-spacing: 0.01em;
}

.field-group span {
  display: none;
}

.field-group .vs-con-input {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  background: #ffffff;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.field-group .vs-con-input:focus-within {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group .vs-inputx.vs-input--input.normal {
  border: none;
  background: transparent;
  padding: 12px 16px;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #0f172a;
}

.field-group ::v-deep(.vs__dropdown-toggle) {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  padding: 6px 14px;
  min-height: 44px;
  background-color: #ffffff;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
}

.field-group ::v-deep(.vs__dropdown-toggle:focus),
.field-group ::v-deep(.vs__dropdown-toggle.vs__dropdown-toggle--focus) {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group ::v-deep(.vs__dropdown-menu) {
  border-radius: 12px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.15);
  margin-top: 6px;
}

.modern-modal ::v-deep(.vs-button) {
  min-height: 44px;
  padding: 0 22px;
  border-radius: 10px;
  font-weight: 600;
}

@media (max-width: 1024px) {
  .modern-modal__overlay {
    left: 0;
  }
}

@media (max-width: 768px) {
  .modern-modal {
    width: min(540px, 96vw);
    max-height: 82vh;
  }

  .modern-modal__header,
  .modern-modal__body,
  .modern-modal__footer {
    padding-left: 20px;
    padding-right: 20px;
  }

  .modern-modal__overlay {
    padding: 24px;
  }
}

@media (max-width: 640px) {
  .modern-modal__header {
    flex-direction: column;
    align-items: stretch;
  }

  .modern-modal__close {
    align-self: flex-end;
  }
}
</style>
